import React, { useEffect, useRef, useState } from 'react'
import './home.css'
import TredingTopics from './TredingTopics'
import { DownloadApp } from './DownloadApp'
import { LatestCourse } from './LatestCourse'
import { FeedBack } from './FeedBack'
import { miscService } from '../service/misc.service'
import { News } from './News'
import { Blogs } from './OurBlog'
import { AnimatedCounter } from './AnimatedCounter'
import SEO from './SEO'

const Home = () => {
    const [countData, setCountData] = useState({})

    const latestCourseRef = useRef(null)

    useEffect(() => {
        getDashboardCounts()
    }, [])


    const getDashboardCounts = async () => {
        try {
            const response = await miscService.dahsboradCount()

            // console.log(response, "this is dashcount response")
            if (response?.data) {

                setCountData(response.data)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleLatestCourseRef = () => {
        if (latestCourseRef.current) {
            latestCourseRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div className=''>
            <SEO
                title="Home - Your Gateway to Mastering Arabic Language Competitive Exams"
                description="Explore India's premier online test series platform for Arabic language competitive exams. Dive into our extensive collection of MCQs, adaptive learning paths, and real-time progress tracking."
                image=""
                url="https://edraakonline.com/"
            />

            <div className=" container getstartedcontainer ">
                <div className="getstartedcontent">
                    <div className='getstarted-firsttxt'>India’s Premier Online Test Series Platform.</div>
                    <div className="getstarted-headtxt">
                        <span>Gateway to </span><br />
                        <span className='head-hilight'>Mastering Arabic Language </span><br />
                        <span>Competitive Exams</span><br />
                    </div>
                    <div className="getstarted-desc">Dive into our extensive collection of MCQs, meticulously crafted to reinforce your understanding of key concepts.</div>
                    <div className="getstarted-btn-container">
                        <div onClick={() => window.location.href = 'https://app.edraakonline.com/login'} className="getstarted-btn">Get Started</div>
                        <div onClick={handleLatestCourseRef} className="discover-course-btn">Discover courses</div>
                    </div>
                </div>
                <img src="/assets/img/mainimg.png" alt="Get Started" className='getstated-img' />
            </div>

            <div className="desc-container container">
                <div data-aos="fade-left" className="count-container">
                    <div className="countitem">
                        <div className="counttxt">
                            <AnimatedCounter end={countData?.total_courses || 0} suffix="+" />
                        </div>
                        <div className="countdesc">Courses listed in app</div>
                    </div>

                    <div className="countitem">
                        <div className="counttxt">
                            <AnimatedCounter end={countData?.total_subjects || 0} suffix="+" />
                        </div>
                        <div className="countdesc">Subjects covered</div>
                    </div>

                    <div className="countitem">
                        <div className="counttxt"><AnimatedCounter end={countData?.total_topics || 0} suffix="+" /></div>
                        <div className="countdesc">Trending Topics</div>
                    </div>
                </div>
                <div data-aos="fade-right" className="desc-content">
                    <div className="desc-head">India’s premier Online Test Series Platform.
                        Our Mock Tests are designed to simulate real exam conditions, providing you with a strategic edge. </div>
                    <div className="desc-para">
                        <p className='desc-txt'>Dive into our extensive collection of MCQs, meticulously crafted to reinforce your understanding of key concepts. Level Up Your Learning with Image & Definition-Based MCQs!
                            Introducing Comprehensive Course Coverage: EDRAAK covers all the</p>
                        <p className='desc-txt'>essential topics which tested in major Arabic language competitive exams, including:
                            Arabic Linguistics, Grammar, Vocabulary & Idioms, Reading Comprehension, Arabic Literature & Culture, and Islamic Studies.</p>
                    </div>
                </div>
            </div>
            <div data-aos="fade-up" className="shortpoint-container container">
                <div className="point-item">
                    <img src="/assets/img/mocktesticon.png" alt="Mock Test Icon" className='point-img' />
                    Unlimited Mock tests
                </div>
                <div className="point-item">
                    <img src="/assets/img/adaptive.png" alt="Mock Test Icon" className='point-img' />
                    Adaptive Learning Paths
                </div>
                <div className="point-item">
                    <img src="/assets/img/progress.png" alt="Mock Test Icon" className='point-img' />
                    Real time Progress
                </div>
                <div className="point-item">
                    <img src="/assets/img/mcqcollection.png" alt="Mock Test Icon" className='point-img' />
                    Wide Range MCQ Collection
                </div>
            </div>

            <TredingTopics />
            <DownloadApp />
            <div ref={latestCourseRef}>
                <LatestCourse />
            </div>
            <FeedBack />
            {/* <News/> */}
            <Blogs />
        </div>
    )
}

export default Home